import { render } from "./OtherCoverages.vue?vue&type=template&id=048ec9b5&ts=true"
import script from "./OtherCoverages.vue?vue&type=script&lang=ts"
export * from "./OtherCoverages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__